import AdvertisersService from "../../../../services/advertisersDataService";

export default {
  data(){
    return{
      advertisers: [],
    }
  },
  methods:{
    getAdvertisers(){
      AdvertisersService.getAllAdvertisers()
        .then(advertisers => {
          advertisers.forEach((value) => {
            this.advertisers.push({
              label: value.legal_title,
              value: value.id
            })
          })
        })
    },
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/Advertiser/advertiserFormMixin.js